import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import DashboardLayout from "../../../layout/dashboard/DashboardLayout";
import TitleTextBox from "../../../fragments/TitleTextBox";
import "../../../styles/dashboard/insights/TerminalDetailsInsight.css";
import visaIcon from "../../../assets/visa-icon.svg";
import verveIcon from "../../../assets/verve-icon.svg";
import masterIcon from "../../../assets/master-icon.svg";
import {
  RavenButton,
  RavenInputField,
  RavenModal,
  RavenTable,
  RavenTableRow,
  RavenToolTip,
} from "@ravenpay/raven-bank-ui";
import BadgeComponent from "../../../fragments/badge/BadgeComponent";
import FilterFragment from "../../../fragments/FilterFragment";
import ExportFragment from "../../../fragments/ExportFragment";
import PaginationFragment from "../../../fragments/PaginationFragment";
import ContainerWrapper from "../../../fragments/ContainerWrapper";
import { useNavigate } from "react-router-dom";
import { RouteLinks } from "../../../routes/RouteLinks";
import { decrypt2 } from "../../../utils/encrypt";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import {
  SET_GET_STREAM_KEY,
  deleteStreamKey,
  getAlertReceivers,
  getSingleInsightTerminalTransactions,
  getSingleInsightTerminals,
  getStreamKey,
} from "../../../redux/insight";
import {
  formatDate,
  formatMetaData,
  formatNumWithCommaNairaSymbol,
  // formatTypeFunction,
  lowerCaseWrap,
  trimLongString,
} from "../../../helper";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {
  convertToLowercase,
  // checkStatusColor,
  detectCardType,
  identifyNetwork,
  maskCardNumber,
  // actionCtx.perPageGlobalVal?.value,
} from "../../../utils/helpers";
import { debounce } from "lodash";
import TransactionDetailModal from "../modal/TransactionDetailModal";
import ExportModal from "../modal/ExportModal";
import ActionContext from "../../../context/ActionContext";
import MobileTableCard from "../../../fragments/MobileTableWrap";
import TwoDetailView from "../../../fragments/TwoDetailView";
import ImageTextFragment from "../../../fragments/ImageTextFragment";
import PerPageComponent from "../../../fragments/PerPageComponent";
import { useOnClickOutsideTwo } from "../../../utils/useOutsideClickTwo";
import AlertReceivers from "./alert-modals/AlertReceivers";
import DeleteAlertRecieverModal from "./alert-modals/DeleteAlertRecieverModal";
import AddAlertReceiver from "./alert-modals/AddAlertReciever";
import FlierTwoIndex from "./FlierTwoBox/FlierTwoIndex";
import DateFragmentBox from "../../../fragments/DateFragmentBox";
import RavenIconButton from "../../../components/IconBotton";
import CreateStreamModal from "./streamModals/createStreammodal";
import RavenIconRightButton from "../../../components/IconRightBotton";
import ManageStreamModal from "./streamModals/manageStreamKeyModal";
import Icons from "../../../assets/icons/icons";
import { TerminalIcon } from "../../../assets/icons/TerminalIcon";

const TerminalDetailsInsight = () => {
  const dispatch = useDispatch();
  const [currentPageVal, setCurrentPageVal] = useState(1);
  const [singleObj, setsingleObj] = useState({});
  const [search, setSearch] = useState("");
  const actionCtx = useContext(ActionContext);

  const {
    loading,
    insight_terminal,
    insight_terminal_trx,
    alert_receivers,
    stream_key_info,
    loading_reciept,
  } = useSelector((state: RootState) => state.insights);

  const navigate = useNavigate();
  const tableList = [
    "REFERENCE",
    "TERMINAL LABEL",
    "TERMINAL ID",
    "TYPE",
    "AMOUNT",
    "STATUS",
    "TRANSACTION DATE",
  ];

  type showModalProp = {
    view: boolean;
    export?: boolean;
    view_alert: boolean;
    add_alert: boolean;
    delete_view_alert: boolean;
    view_flier: boolean;
    create_stream_key: boolean;
    manage_stream_key: boolean;
  };
  const [showModal, setShowModal] = useState<showModalProp>({
    view: false,
    export: false,
    view_alert: false,
    view_flier: false,
    add_alert: false,
    delete_view_alert: false,
    create_stream_key: false,
    manage_stream_key: false,
  });
  const [noListFound, setNoListFound] = useState(true);
  const [singleChild, setSingleChild] = useState({});

  useEffect(() => {
    if (Object?.keys(actionCtx?.configDetails)?.length > 0) {
      const serialVal = localStorage?.getItem("takwoski");
      if (serialVal) {
        const decryptedVal = decrypt2(serialVal ?? "");
        getTerminalDetails(decryptedVal);
      } else {
        navigate(RouteLinks.Insights);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionCtx?.configDetails]);

  const decryptedserialVal = () => {
    const serialVal = localStorage?.getItem("takwoski");

    if (serialVal) {
      const decryptedVal = decrypt2(serialVal);

      return decryptedVal;
    }
  };

  const getTerminalDetails = async (param: any) => {
    const obj = {
      serial: param,
    };
    dispatch(getSingleInsightTerminals(obj as any) as any);
  };

  const manageStreamOptions = [
    {
      label: "Stream Transactions",
      img: Icons.manageStreamIcon,
      onclick: () => {
        const url = `https://${actionCtx?.configDetails?.partnerInfo?.prefix}.bankbox.me/`;
        window.open(url);
      },
    },
    {
      label: "Manage Stream Key",
      img: Icons.streamKeyBlack,

      onclick: () => {
        setShowModal((prev) => ({
          ...prev,
          manage_stream_key: true,
        }));
      },
    },
  ];

  const fetchStreamKey = async (account_number: string) => {
    const userDetails: UserDetails = {
      account_number,
    };

    dispatch(getStreamKey(userDetails as any) as any);
  };

  const [checkFetch, setCheckFetch] = useState(false);

  useEffect(() => {
    const accountNumber =
      insight_terminal?.terminalData?.account_info?.account_number;
    setCheckFetch(true);
    if (accountNumber) {
      fetchStreamKey(accountNumber);
      setCheckFetch(false);
    } else {
      dispatch(SET_GET_STREAM_KEY({}));
      setCheckFetch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [insight_terminal]);

  useEffect(() => {
    if (Object?.keys(actionCtx?.configDetails)?.length > 0) {
      const serialVal = localStorage?.getItem("takwoski");
      if (serialVal) {
        const decryptedVal = decrypt2(serialVal ?? "");
        getTerminalDetailsTrans(decryptedVal);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPageVal, actionCtx.perPageGlobalVal, actionCtx?.configDetails]);

  const getTerminalDetailsTrans = async (param: any) => {
    const obj = {
      serial: param,
      perPage: actionCtx.perPageGlobalVal?.value,
      currentPage: currentPageVal,
    };
    const data = await dispatch(
      getSingleInsightTerminalTransactions(obj as any) as any
    );
    if (data?.payload?.status === "success") {
      if (data?.payload?.data?.data?.transactions?.length > 0) {
        setNoListFound(false);
      }
    }
  };

  const handleSearch = debounce((param: any) => {
    const serialVal = localStorage?.getItem("takwoski");
    const decryptedVal = decrypt2(serialVal ?? "");
    const obj = {
      serial: decryptedVal,
      search: param,
    };
    if (param?.length > 0) {
      dispatch(getSingleInsightTerminalTransactions(obj as any) as any);
    } else {
      getTerminalDetailsTrans(decryptedVal);
    }
  }, 500);

  const bankDefaultImg = (
    <svg
      className="img"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 4.49952V8.49952M4.75 4.49952V8.49952M7.25 4.49952V8.49952M9.5 4.49952V8.49952M1.5 9.29952L1.5 9.69952C1.5 9.97955 1.5 10.1196 1.5545 10.2265C1.60243 10.3206 1.67892 10.3971 1.773 10.445C1.87996 10.4995 2.01997 10.4995 2.3 10.4995H9.7C9.98003 10.4995 10.12 10.4995 10.227 10.445C10.3211 10.3971 10.3976 10.3206 10.4455 10.2265C10.5 10.1196 10.5 9.97955 10.5 9.69952V9.29952C10.5 9.0195 10.5 8.87948 10.4455 8.77253C10.3976 8.67845 10.3211 8.60196 10.227 8.55402C10.12 8.49952 9.98003 8.49952 9.7 8.49952H2.3C2.01997 8.49952 1.87996 8.49952 1.773 8.55402C1.67892 8.60196 1.60243 8.67845 1.5545 8.77253C1.5 8.87948 1.5 9.0195 1.5 9.29952ZM5.82646 1.53809L2.12646 2.36031C1.90293 2.40998 1.79116 2.43482 1.70773 2.49492C1.63415 2.54794 1.57636 2.61997 1.54057 2.7033C1.5 2.79778 1.5 2.91228 1.5 3.14126L1.5 3.69952C1.5 3.97955 1.5 4.11956 1.5545 4.22652C1.60243 4.3206 1.67892 4.39709 1.773 4.44502C1.87996 4.49952 2.01997 4.49952 2.3 4.49952H9.7C9.98003 4.49952 10.12 4.49952 10.227 4.44502C10.3211 4.39709 10.3976 4.3206 10.4455 4.22652C10.5 4.11956 10.5 3.97955 10.5 3.69952V3.14126C10.5 2.91228 10.5 2.79778 10.4594 2.70331C10.4236 2.61997 10.3659 2.54794 10.2923 2.49492C10.2088 2.43482 10.0971 2.40998 9.87354 2.36031L6.17354 1.53809C6.10878 1.5237 6.0764 1.5165 6.04368 1.51363C6.01461 1.51108 5.98538 1.51108 5.95632 1.51363C5.9236 1.5165 5.89122 1.5237 5.82646 1.53809Z"
        stroke="#0B8376"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const getImageFunc = async (param: any) => {
    // console.log(param, "---------");
    if (param) {
      const img =
        await `https://businessapi.getraventest.com/static/media/banks/${param}.png`;
      // console.log(img);

      return img ? img : "";
    }
  };

  const settingsIcon = (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="img"
    >
      <g clipPath="url(#clip0_1897_11864)">
        <path
          d="M7.81169 10.4997C8.8903 10.4997 9.76468 9.60424 9.76468 8.49967C9.76468 7.39511 8.8903 6.49967 7.81169 6.49967C6.73309 6.49967 5.85871 7.39511 5.85871 8.49967C5.85871 9.60424 6.73309 10.4997 7.81169 10.4997Z"
          stroke="#646464"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="dull-bright-filter"
        />
        <path
          d="M12.1911 10.3179C12.1123 10.5007 12.0888 10.7034 12.1236 10.9C12.1584 11.0966 12.25 11.2781 12.3864 11.4209L12.4219 11.4573C12.532 11.5698 12.6193 11.7035 12.6788 11.8507C12.7384 11.9978 12.7691 12.1555 12.7691 12.3148C12.7691 12.4741 12.7384 12.6318 12.6788 12.779C12.6193 12.9261 12.532 13.0598 12.4219 13.1724C12.312 13.2851 12.1814 13.3745 12.0378 13.4355C11.8941 13.4965 11.74 13.5279 11.5845 13.5279C11.429 13.5279 11.2749 13.4965 11.1312 13.4355C10.9876 13.3745 10.857 13.2851 10.7471 13.1724L10.7116 13.136C10.5721 12.9963 10.3949 12.9026 10.203 12.8669C10.011 12.8313 9.81298 12.8554 9.63448 12.936C9.45944 13.0129 9.31015 13.1404 9.205 13.303C9.09985 13.4656 9.04342 13.6562 9.04266 13.8512V13.9542C9.04266 14.2757 8.91796 14.584 8.69599 14.8113C8.47402 15.0386 8.17296 15.1663 7.85904 15.1663C7.54512 15.1663 7.24406 15.0386 7.02209 14.8113C6.80012 14.584 6.67541 14.2757 6.67541 13.9542V13.8997C6.67083 13.6991 6.60743 13.5045 6.49344 13.3413C6.37945 13.1781 6.22015 13.0538 6.03626 12.9845C5.85776 12.9038 5.65975 12.8798 5.46777 12.9154C5.27579 12.9511 5.09864 13.0448 4.95916 13.1845L4.92365 13.2209C4.81372 13.3336 4.68318 13.423 4.53949 13.484C4.3958 13.545 4.24178 13.5764 4.08624 13.5764C3.93069 13.5764 3.77667 13.545 3.63298 13.484C3.48929 13.423 3.35875 13.3336 3.24882 13.2209C3.13877 13.1083 3.05147 12.9746 2.9919 12.8275C2.93234 12.6803 2.90168 12.5226 2.90168 12.3633C2.90168 12.204 2.93234 12.0463 2.9919 11.8991C3.05147 11.752 3.13877 11.6183 3.24882 11.5057L3.28433 11.4694C3.42076 11.3265 3.51229 11.1451 3.5471 10.9485C3.58191 10.7519 3.55841 10.5491 3.47963 10.3663C3.40461 10.1871 3.28004 10.0342 3.12126 9.92653C2.96249 9.81885 2.77643 9.76106 2.58599 9.76028H2.48538C2.17147 9.76028 1.87041 9.63258 1.64843 9.40526C1.42646 9.17794 1.30176 8.86963 1.30176 8.54816C1.30176 8.22668 1.42646 7.91838 1.64843 7.69106C1.87041 7.46374 2.17147 7.33604 2.48538 7.33604H2.53865C2.73453 7.33135 2.92451 7.26641 3.08388 7.14968C3.24325 7.03295 3.36465 6.86982 3.43228 6.68149C3.51106 6.4987 3.53456 6.29592 3.49975 6.09932C3.46494 5.90271 3.37342 5.7213 3.23698 5.57846L3.20148 5.5421C3.09143 5.42953 3.00412 5.29584 2.94456 5.14869C2.88499 5.00154 2.85433 4.84381 2.85433 4.68452C2.85433 4.52523 2.88499 4.3675 2.94456 4.22035C3.00412 4.0732 3.09143 3.93952 3.20148 3.82695C3.3114 3.71425 3.44194 3.62484 3.58563 3.56384C3.72932 3.50285 3.88334 3.47145 4.03889 3.47145C4.19444 3.47145 4.34846 3.50285 4.49215 3.56384C4.63584 3.62484 4.76638 3.71425 4.8763 3.82695L4.91181 3.86331C5.05129 4.00303 5.22844 4.09676 5.42042 4.1324C5.6124 4.16805 5.81041 4.14399 5.98891 4.06331H6.03626C6.2113 3.98648 6.36058 3.85892 6.46573 3.69632C6.57088 3.53372 6.62731 3.34318 6.62807 3.14816V3.04513C6.62807 2.72365 6.75277 2.41535 6.97475 2.18803C7.19672 1.96071 7.49778 1.83301 7.81169 1.83301C8.12561 1.83301 8.42667 1.96071 8.64864 2.18803C8.87062 2.41535 8.99532 2.72365 8.99532 3.04513V3.09967C8.99608 3.2947 9.05251 3.48524 9.15766 3.64784C9.26281 3.81044 9.41209 3.938 9.58713 4.01483C9.76563 4.0955 9.96364 4.11957 10.1556 4.08392C10.3476 4.04827 10.5248 3.95455 10.6642 3.81483L10.6997 3.77846C10.8097 3.66576 10.9402 3.57636 11.0839 3.51536C11.2276 3.45436 11.3816 3.42296 11.5372 3.42296C11.6927 3.42296 11.8467 3.45436 11.9904 3.51536C12.1341 3.57636 12.2646 3.66576 12.3746 3.77846C12.4846 3.89104 12.5719 4.02472 12.6315 4.17187C12.6911 4.31902 12.7217 4.47675 12.7217 4.63604C12.7217 4.79533 12.6911 4.95306 12.6315 5.10021C12.5719 5.24736 12.4846 5.38104 12.3746 5.49361L12.3391 5.52998C12.2026 5.67281 12.1111 5.85423 12.0763 6.05083C12.0415 6.24744 12.065 6.45021 12.1438 6.63301V6.68149C12.2188 6.86075 12.3433 7.01362 12.5021 7.12131C12.6609 7.22899 12.847 7.28678 13.0374 7.28755H13.138C13.4519 7.28755 13.753 7.41526 13.975 7.64258C14.1969 7.86989 14.3216 8.1782 14.3216 8.49967C14.3216 8.82115 14.1969 9.12946 13.975 9.35677C13.753 9.58409 13.4519 9.7118 13.138 9.7118H13.0847C12.8943 9.71257 12.7082 9.77036 12.5495 9.87804C12.3907 9.98573 12.2661 10.1386 12.1911 10.3179Z"
          stroke="#646464"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="dull-bright-filter"
        />
      </g>
      <defs>
        <clipPath id="clip0_1897_11864">
          <rect
            width="15.6238"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const getImageCardFunc = (param: any) => {
    let val;
    if (param) {
      const checkText =
        detectCardType(param) === "Visa"
          ? visaIcon
          : detectCardType(param) === "Master"
          ? masterIcon
          : verveIcon;
      val = checkText;
    }
    return val;
  };

  const viewIcon = (
    <svg
      className="img"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="dull-bright-filter"
        d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="dull-bright-filter"
        d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // const editIcon = (
  //   <svg
  //     className="img"
  //     width="24"
  //     height="24"
  //     viewBox="0 0 24 24"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <path
  //       d="M21 18.0002L19.9999 19.0943C19.4695 19.6744 18.7501 20.0002 18.0001 20.0002C17.2501 20.0002 16.5308 19.6744 16.0004 19.0943C15.4692 18.5154 14.75 18.1903 14.0002 18.1903C13.2504 18.1903 12.5311 18.5154 12 19.0943M3 20.0002H4.67454C5.16372 20.0002 5.40832 20.0002 5.63849 19.945C5.84256 19.896 6.03765 19.8152 6.2166 19.7055C6.41843 19.5818 6.59138 19.4089 6.93729 19.063L19.5 6.50023C20.3285 5.6718 20.3285 4.32865 19.5 3.50023C18.6716 2.6718 17.3285 2.6718 16.5 3.50023L3.93726 16.063C3.59136 16.4089 3.4184 16.5818 3.29472 16.7837C3.18506 16.9626 3.10425 17.1577 3.05526 17.3618C3 17.5919 3 17.8365 3 18.3257V20.0002Z"
  //       stroke="black"
  //       strokeWidth="1.2"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       className="dull-bright-filter"
  //     />
  //   </svg>
  // );

  const addIcon = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="img"
    >
      <path
        className="dull-bright-filter"
        d="M12 5V19M5 12H19"
        stroke="#020202"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  const generateIcon = (
    <svg
      className="img"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.1198 22 8.79986 22H12.5M14 11H8M10 15H8M16 7H8M15 19L18 22M18 22L21 19M18 22V16"
        stroke="black"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="dull-bright-filter"
      />
    </svg>
  );

  interface UserDetails {
    account_number?: string;
    clear_keys?: string;
    use_key?: string;
    expire_at?: string;
    history_enabled?: boolean;
  }

  function addHashIfNeeded(str: any) {
    if (/\d/.test(str) && !/^#/.test(str)) {
      return "#" + str;
    } else {
      return str;
    }
  }

  const [showDrop, setShowDrop] = useState(false);

  useEffect(() => {
    console.log("");
  }, [stream_key_info]);

  const testingFilterFragRef = useOnClickOutsideTwo(() => {
    setShowDrop(false);
  });
  const [showManagedropdown, setShowManageDropDown] = useState(false);
  const manageModalRef = useOnClickOutsideTwo(() => {
    setShowManageDropDown(false);
  });

  const [fromView, setFromView] = useState(false);

  const getAlertRecieversFunction = async () => {
    // console.log("oid");

    if (insight_terminal?.terminalData?.terminal?.tid) {
      const obj = {
        id: insight_terminal?.terminalData?.terminal?.tid,
      };
      dispatch(getAlertReceivers(obj as any) as any);
    }
  };
  // console.log(actionCtx?.configDetails);

  const settingsItems = [
    {
      name: "View alert recievers",
      icon: viewIcon,
      onclick: () => {
        setShowDrop(false);
        if (alert_receivers?.length < 1) {
          getAlertRecieversFunction();
        }

        setShowModal((prev) => {
          return { ...prev, view_alert: true };
        });
      },
    },
    {
      name: "Add alert recievers",
      icon: addIcon,
      onclick: () => {
        setShowDrop(false);
        setShowModal((prev) => {
          return { ...prev, add_alert: true };
        });
      },
    },
    {
      name: "View payment flier",
      icon: generateIcon,
      onclick: () => {
        console.log("on click");
        setShowDrop(false);
        setShowModal((prev) => {
          return { ...prev, view_flier: true };
        });
      },
    },

    {
      name:
        Object.keys(stream_key_info || {}).length > 0
          ? "Manage stream key"
          : "Create stream key",
      icon: addIcon,
      onclick: () => {
        Object?.keys(stream_key_info)?.length > 0
          ? setShowModal((prev) => ({
              ...prev,
              manage_stream_key: true,
            }))
          : setShowModal((prev) => ({
              ...prev,
              create_stream_key: true,
            }));
      },
    },
  ];

  return (
    <>
      <DashboardLayout>
        {/* title box start */}
        {(!loading || !loading_reciept) && (
          <TitleTextBox
            text="Manage Bankbox devices on the platform."
            title="Terminal Details"
            back={true}
            onBack={() => {
              navigate(-1 || RouteLinks?.Insights);
              // console.log(insight_terminal);
            }}
          >
            {insight_terminal &&
              !loading_reciept &&
              !checkFetch &&
              !loading && (
                <div
                  ref={testingFilterFragRef}
                  className="settings-icon-drop-box-wrap"
                  style={{ gap: "2rem" }}
                  onClick={() => {
                    // console.log(stream_key_info);
                  }}
                >
                  {(!loading_reciept || !loading) && (
                    <div className="icon-botton-wrap" ref={manageModalRef}>
                      {Object?.keys(stream_key_info)?.length > 0 ? (
                        <div>
                          <RavenIconRightButton
                            btnClassName="grey-bg black-white-color"
                            text="Manage Streaming"
                            icon={Icons.vArrowDown}
                            className="raven_icon_color_button"
                            onBtnClick={() => {
                              // setIsManageOpen(true)
                              setShowManageDropDown((prev) => !prev);
                              showDrop && setShowDrop(false);
                            }}
                          />
                          {showManagedropdown && (
                            <div
                              className="drop-down-icon-box card-bg border-theme"
                              style={{ marginTop: "1rem" }}
                            >
                              {/* icon text box start */}

                              {manageStreamOptions.map((item, index) => (
                                <div
                                  key={index}
                                  className="icon-text-box"
                                  onClick={item.onclick}
                                >
                                  <div className="icon-img-box">
                                    <figure className="img-box">
                                      {item.img}
                                    </figure>
                                  </div>
                                  <p className="text grey-white-color">
                                    {item.label}
                                  </p>
                                </div>
                              ))}

                              {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      if (alert_receivers?.lengt  h < 1) {
                        getAlertRecieversFunction();
                      }

                      setShowModal((prev) => {
                        return { ...prev, view_alert: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{viewIcon}</figure>
                    </div>
                    <p className="text grey-white-color">View alert receiver</p>
                  </div> */}
                              {/* icon text box end */}
                              {/* icon text box start */}
                              {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      setShowModal((prev) => {
                        return { ...prev, add_alert: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{addIcon}</figure>
                    </div>
                    <p className="text grey-white-color">Add alert receiver</p>
                  </div> */}
                              {/* icon text box end */}
                              {/* icon text box start */}
                              {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      setShowModal((prev) => {
                        return { ...prev, view_flier: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{generateIcon}</figure>
                    </div>
                    <p className="text grey-white-color">View Payment flier</p>
                  </div> */}
                              {/* icon text box end */}
                              {/* icon text box start */}
                              {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      setShowModal((prev) => {
                        return { ...prev, view_flier: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{addIcon}</figure>
                    </div>
                    <p className="text grey-white-color">Create Stream Key</p>
                  </div> */}
                              {/* icon text box end */}
                            </div>
                          )}
                        </div>
                      ) : (
                        <RavenIconButton
                          text="Create Stream Key "
                          backgroundColor="blue-light"
                          onBtnClick={() => {
                            setShowModal((prev) => ({
                              ...prev,
                              create_stream_key: true,
                            }));
                          }}
                        />
                      )}
                    </div>
                  )}
                  <div
                    onClick={() => {
                      showManagedropdown && setShowManageDropDown(false);
                      setShowDrop(!showDrop);
                    }}
                    className="icon-box-wrap card-bg border-theme"
                  >
                    <figure className="img-box">{settingsIcon}</figure>
                  </div>
                  {/* drop down icon box sytarrt */}
                  {showDrop && (
                    <div className="drop-down-icon-box card-bg border-theme">
                      {/* icon text box start */}

                      {settingsItems.map((item, index) => (
                        <div
                          key={index}
                          className="icon-text-box"
                          onClick={item.onclick}
                        >
                          <div className="icon-img-box">
                            <figure className="img-box">{item.icon}</figure>
                          </div>
                          <p className="text grey-white-color">{item.name}</p>
                        </div>
                      ))}

                      {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      if (alert_receivers?.length < 1) {
                        getAlertRecieversFunction();
                      }

                      setShowModal((prev) => {
                        return { ...prev, view_alert: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{viewIcon}</figure>
                    </div>
                    <p className="text grey-white-color">View alert receiver</p>
                  </div> */}
                      {/* icon text box end */}
                      {/* icon text box start */}
                      {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      setShowModal((prev) => {
                        return { ...prev, add_alert: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{addIcon}</figure>
                    </div>
                    <p className="text grey-white-color">Add alert receiver</p>
                  </div> */}
                      {/* icon text box end */}
                      {/* icon text box start */}
                      {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      setShowModal((prev) => {
                        return { ...prev, view_flier: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{generateIcon}</figure>
                    </div>
                    <p className="text grey-white-color">View Payment flier</p>
                  </div> */}
                      {/* icon text box end */}
                      {/* icon text box start */}
                      {/* <div
                    onClick={() => {
                      setShowDrop(false);
                      setShowModal((prev) => {
                        return { ...prev, view_flier: true };
                      });
                    }}
                    className="icon-text-box"
                  >
                    <div className="icon-img-box">
                      <figure className="img-box">{addIcon}</figure>
                    </div>
                    <p className="text grey-white-color">Create Stream Key</p>
                  </div> */}
                      {/* icon text box end */}
                    </div>
                  )}
                  {/* drop down icon box end */}
                </div>
              )}
          </TitleTextBox>
        )}
        {loading || loading_reciept ? (
          <ContainerWrapper
            width={`100%`}
            dontShowHeader
            noContent={true}
            noContentLoading={true}
          />
        ) : (
          <>
            {/* title box end */}
            <div
              // onClick={() => {
              //   // console.log(insight_terminal_trx);
              //   // console.log(insight_terminal, "----------");
              // }}
              className="transaction-dashboard-index-wrap-insight-details-main"
            >
              {" "}
              {/* top detail wrap start */}
              <div className="top-detail-wrap-insight-box card-bg border-theme">
                <div className="left-box-wrap">
                  <div className="wrap-content grey-bg">
                    <div className="img-wrapper">
                      <figure className="img-box">
                        {TerminalIcon?.terminal}
                      </figure>
                    </div>
                  </div>
                </div>
                {/* end of left wrap */}
                {/* right box starrt */}
                <div className="right-box-wrap">
                  <div className="wrap-content">
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Terminal ID</p>
                      <p className="value">
                        {insight_terminal?.terminalData?.terminal?.tid ||
                          "-nn--"}
                      </p>
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Terminal Label</p>
                      <p className="value">
                        {lowerCaseWrap(
                          insight_terminal?.terminalData?.terminal?.tid_label
                        ) || "---"}
                      </p>
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Serial Number</p>
                      {/* {insight_terminal?.terminalData?.length > 0 && ( */}
                      <div className="value tooltip-hover-wrap">
                        {insight_terminal?.terminalData?.terminal?.serial
                          ? trimLongString(
                              insight_terminal?.terminalData?.terminal?.serial,
                              15
                            )
                          : "---"}{" "}
                        {insight_terminal?.terminalData?.terminal?.serial
                          ?.length > 14 && (
                          <RavenToolTip
                            color="deep-green-light"
                            position={`bottom-center` as any}
                            text={
                              insight_terminal?.terminalData?.terminal?.serial
                            }
                          />
                        )}
                      </div>
                      {/* )} */}
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Volume</p>
                      <p className="value">
                        {formatNumWithCommaNairaSymbol(
                          insight_terminal?.summary?.volume
                        ) || "---"}
                      </p>
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Date Disbursed</p>
                      <p className="value">
                        {formatDate(
                          insight_terminal?.terminalData?.terminal?.created_at
                        )?.split("—")[0] || "---"}
                      </p>
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}

                    <div className="label-value-box">
                      <p className="label grey-white-color">Account number</p>
                      <p className="value">
                        {insight_terminal?.terminalData?.account_info
                          ?.account_number || "---"}
                      </p>
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Account Name</p>
                      {/* {insight_terminal?.terminalData?.length > 0 && ( */}
                      <div className="value tooltip-hover-wrap">
                        {trimLongString(
                          insight_terminal?.terminalData?.account_info
                            ?.account_name,
                          20
                        ) || "---"}{" "}
                        {insight_terminal?.terminalData?.account_info
                          ?.account_name?.length > 20 && (
                          <RavenToolTip
                            color="deep-green-light"
                            position={`bottom-center` as any}
                            text={
                              insight_terminal?.terminalData?.account_info
                                ?.account_name
                            }
                          />
                        )}
                      </div>
                      {/* )} */}
                      {/* <p className="value">{insight_terminal?.terminalData[0]?.account_name || "---"}</p> */}
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Bank</p>
                      <p className="value">
                        {insight_terminal?.terminalData?.account_info?.bank ||
                          "---"}
                      </p>
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Status</p>
                      {/* {insight_terminal?.terminalData?.length > 0 && ( */}
                      <div className="value ">
                        {" "}
                        {String(
                          insight_terminal?.terminalData?.terminal?.status
                        ) ? (
                          <BadgeComponent
                            text={
                              String(
                                insight_terminal?.terminalData?.terminal?.status
                              ) === "1"
                                ? `Active`
                                : `Inactive`
                            }
                            className={
                              String(
                                insight_terminal?.terminalData?.terminal?.status
                              ) === "1"
                                ? `success`
                                : `failed`
                            }
                          />
                        ) : (
                          "---"
                        )}
                        {/* active */}
                      </div>
                      {/* )} */}
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Cash In</p>
                      <p className="value">
                        {formatNumWithCommaNairaSymbol(
                          insight_terminal?.summary?.cashIn
                        ) || "---"}
                      </p>
                    </div>
                    {/* box value label end */}
                    {/* box value label start */}
                    <div className="label-value-box">
                      <p className="label grey-white-color">Cash Out</p>
                      <p className="value">
                        {formatNumWithCommaNairaSymbol(
                          insight_terminal?.summary?.cashOut
                        ) || "---"}
                      </p>
                    </div>
                    {/* box value label end */}
                  </div>
                  <div>
                    <div>
                      {/* <RavenButton 
                    color="purple-light" 
                  label="Create Stream Key"
                    textColor="white-light"
                   
                    /> */}
                    </div>
                  </div>
                </div>
                {/* right box end */}
              </div>
              {/* top detail wrap end */}
            </div>

            {/* contianer starrt */}
            <ContainerWrapper
              dontShowHeader
              noContent={
                insight_terminal_trx?.transactions?.length < 1 && noListFound
                  ? true
                  : false
              }
              noContentText={`There are no transactions currently. Transactions \n made get to show up here.`}
              noContentTitle="No Transactions for now"
              // noContentLoading={true}
              // loading={true}
              className="container-wrapper-insight"
              width={`100%`}
            >
              <div
                // onClick={() => {
                //   console.log();
                // }}
                className="transaction-dashboard-index-wrap-insight-details-main"
              >
                {/* transaction-dashboard index wrap start */}
                <div className="transaction-dashboard-index-wrap-insight-details">
                  {/* serch export filter box start */}
                  <div className="search-export-filter-box">
                    {/* search box start */}
                    <form
                      action=""
                      onSubmit={(e) => {
                        e.preventDefault();
                      }}
                      className="search-box"
                      autoComplete="off"
                    >
                      <RavenInputField
                        color="green-light"
                        type="search"
                        placeholder="Search Transactions"
                        value={search}
                        onChange={(e: any) => {
                          handleSearch(e.target.value);
                          setSearch(e.target.value);
                        }}
                      />
                    </form>
                    {/* search box end */}
                    {/* filter-export pagination box start */}
                    <div className="filter-export-pagination-box">
                      <FilterFragment
                        filters={[
                          {
                            label: "Status",
                            filterBy: "status",
                            options: [
                              {
                                label: "Successful",
                                value: "success",
                              },
                              {
                                label: "Failed",
                                value: "failed",
                              },
                              {
                                label: "Reset",
                                value: "reset",
                              },
                            ],
                          },
                        ]}
                        page="all-single-transactions"
                      />
                      <ExportFragment
                        onClick={() => {
                          setShowModal((prev) => {
                            return { ...prev, export: true };
                          });
                        }}
                      />
                      <PaginationFragment
                        from={
                          insight_terminal_trx?.pagination?.currentPage || "1"
                        }
                        total={insight_terminal_trx?.pagination?.total || "1"}
                        perPageVal={actionCtx.perPageGlobalVal?.value}
                        next={insight_terminal_trx?.pagination?.nextPage}
                        prev={insight_terminal_trx?.pagination?.prevPage}
                        onPrev={() => {
                          setCurrentPageVal(
                            insight_terminal_trx?.pagination?.prevPage
                          );
                        }}
                        onNext={() => {
                          setCurrentPageVal(
                            insight_terminal_trx?.pagination?.nextPage
                          );
                        }}
                      />
                      <PerPageComponent />
                    </div>
                    {/* filter-export pagination box end */}
                  </div>
                  {/* serch export filter box end */}
                  {/* table content start */}
                  <div className="table-content-box">
                    {/* big table start  */}
                    <div className="big-table">
                      <RavenTable headerList={tableList}>
                        {insight_terminal_trx?.data?.map(
                          (chi: any, idx: any) => {
                            return (
                              <RavenTableRow
                                loading={loading}
                                key={idx}
                                one={
                                  <ImageTextFragment
                                    imgUrl={
                                      chi?.type === "airtime"
                                        ? `https://personalbanking.getraventest.com/static/media/mobile/${convertToLowercase(
                                            identifyNetwork(
                                              formatMetaData(chi?.meta_data)
                                                ?.phone_number
                                            )
                                          )}.png`
                                        : chi?.type ===
                                          "merchant_wallet_transfer"
                                        ? ""
                                        : chi?.type === "pdon_card" &&
                                          chi?.meta_data
                                        ? getImageCardFunc(
                                            formatMetaData(chi?.meta_data)
                                              ?.card_pan
                                          )
                                        : chi?.type === "pdon_card" &&
                                          !chi?.meta_data
                                        ? getImageCardFunc(
                                            formatMetaData(chi?.pdon_meta)?.card
                                              ?.card_pan
                                          )
                                        : chi?.type === "transfer_in"
                                        ? getImageFunc(
                                            formatMetaData(chi?.meta_data)
                                              ?.source?.bank_code
                                          )
                                        : chi?.type === "transfer_out"
                                        ? getImageFunc(
                                            formatMetaData(chi?.meta_data)
                                              ?.bank_code
                                          )
                                        : ("" as any)
                                    }
                                    imgVal={
                                      chi?.type === "merchant_wallet_transfer"
                                        ? bankDefaultImg
                                        : chi?.type === "transfer_in"
                                        ? bankDefaultImg
                                        : chi?.type === "transfer_out"
                                        ? bankDefaultImg
                                        : ""
                                    }
                                    textOne={
                                      chi?.type === "airtime"
                                        ? `Airtime Recharge`
                                        : chi?.type ===
                                          "merchant_wallet_transfer"
                                        ? `${trimLongString(
                                            formatMetaData(chi?.meta_data)
                                              ?.account_name,
                                            30
                                          )}`
                                        : chi?.type === "pdon_card" &&
                                          chi?.meta_data
                                        ? maskCardNumber(
                                            formatMetaData(chi?.meta_data)
                                              ?.card_pan
                                          )
                                        : chi?.type === "pdon_card" &&
                                          !chi?.meta_data
                                        ? maskCardNumber(
                                            formatMetaData(chi?.pdon_meta)?.card
                                              ?.card_pan
                                          )
                                        : chi?.type === "transfer_in"
                                        ? `${
                                            formatMetaData(chi?.meta_data)
                                              ?.source?.first_name || ""
                                          } ${
                                            formatMetaData(chi?.meta_data)
                                              ?.source?.last_name || ""
                                          }`
                                        : chi?.type === "transfer_out"
                                        ? formatMetaData(chi?.meta_data)
                                            ?.account_number
                                        : ""
                                    }
                                    textTwo={
                                      chi?.type === "airtime"
                                        ? `${
                                            identifyNetwork(
                                              formatMetaData(chi?.meta_data)
                                                ?.phone_number
                                            ) || ""
                                          } • ${
                                            formatMetaData(chi?.meta_data)
                                              ?.phone_number || ""
                                          } `
                                        : chi?.type ===
                                          "merchant_wallet_transfer"
                                        ? `${
                                            formatMetaData(chi?.meta_data)
                                              ?.account_number
                                          } • ${trimLongString(
                                            formatMetaData(chi?.meta_data)
                                              ?.bank,
                                            20
                                          )}`
                                        : chi?.type === "pdon_card"
                                        ? `${detectCardType(
                                            formatMetaData(chi?.meta_data)
                                              ?.card_pan
                                          )} Card`
                                        : chi?.type === "transfer_in"
                                        ? `${
                                            formatMetaData(chi?.meta_data)
                                              ?.source?.account_number
                                          } • ${
                                            formatMetaData(chi?.meta_data)
                                              ?.source?.bank
                                          }`
                                        : chi?.type === "transfer_out"
                                        ? formatMetaData(chi?.meta_data)?.bank
                                        : ""
                                    }
                                  />
                                }
                                // two={
                                //   lowerCaseWrap(
                                //     formatMetaData(chi?.pdon_meta)
                                //       ?.terminal_profile?.poseidon_label
                                //   ) || "---"
                                // }
                                two={
                                  chi?.type === "merchant_wallet_transfer" ? (
                                    <TwoDetailView
                                      title={`Trx Ref.`}
                                      copy={
                                        formatMetaData(chi?.meta_data)?.trx_ref
                                      }
                                      text_one={trimLongString(
                                        formatMetaData(chi?.meta_data)?.trx_ref,
                                        12
                                      )}
                                    />
                                  ) : chi?.type === "airtime" ? (
                                    <TwoDetailView
                                      title={`Trx Ref.`}
                                      copy={chi?.reference}
                                      text_one={trimLongString(
                                        chi?.reference?.replace("airtime-", ""),
                                        12
                                      )}
                                    />
                                  ) : (
                                    <TwoDetailView
                                      title={
                                        chi?.type !== "transfer_in"
                                          ? chi?.rrn
                                          : `Session ID`
                                      }
                                      copy={
                                        chi?.type === "transfer_in"
                                          ? formatMetaData(chi?.meta_data)
                                              ?.session_id
                                          : ""
                                      }
                                      text_one={
                                        chi?.type !== "transfer_in"
                                          ? `Stan: ${chi?.stan}`
                                          : `${trimLongString(
                                              formatMetaData(chi?.meta_data)
                                                ?.session_id,
                                              15
                                            )}`
                                      }
                                      // text_two={chi?.stan || "--"}
                                    />
                                  )
                                }
                                three={
                                  chi?.type === "airtime" ? (
                                    "Wallet"
                                  ) : chi?.type ===
                                    "merchant_wallet_transfer" ? (
                                    "Wallet"
                                  ) : chi?.type ===
                                    "merchant_wallet_transfer" ? (
                                    "---"
                                  ) : (
                                    <TwoDetailView
                                      text_one={`Label : ${
                                        chi?.type !== "transfer_in"
                                          ? lowerCaseWrap(
                                              formatMetaData(chi?.pdon_meta)
                                                ?.terminal_profile
                                                ?.poseidon_label || ""
                                            )
                                          : lowerCaseWrap(
                                              formatMetaData(chi?.pdon_meta)
                                                ?.terminal?.tid_label || ""
                                            )
                                      }`}
                                      title={
                                        chi?.type !== "transfer_in"
                                          ? formatMetaData(chi?.pdon_meta)
                                              ?.terminal_profile?.poseidon_tid
                                          : chi?.t_id || ""
                                      }
                                      // text_two={chi?.stan}
                                    />
                                  )
                                }
                                four={
                                  chi?.type === "merchant_wallet_transfer"
                                    ? `Settlement`
                                    : chi?.type === "transfer_out"
                                    ? "Transfer out"
                                    : chi?.type === "transfer_in"
                                    ? "Transfer in"
                                    : chi?.type === "airtime"
                                    ? "Airtime"
                                    : "Card"
                                }
                                five={
                                  formatNumWithCommaNairaSymbol(chi?.amount) ||
                                  "---"
                                }
                                onRowClick={() => {
                                  setsingleObj(chi);
                                  setShowModal((prev) => {
                                    return { ...prev, view: true };
                                  });
                                }}
                                six={
                                  <BadgeComponent
                                    text={
                                      String(chi?.status) === "00"
                                        ? `Success`
                                        : `Failed`
                                    }
                                    className={
                                      String(chi?.status) === "00"
                                        ? `success`
                                        : `failed`
                                    }
                                  />
                                }
                                // six={
                                //   <BadgeComponent
                                //     text={
                                //       String(
                                //         formatMetaData(chi?.pdon_meta)?.card
                                //           ?.response_code
                                //       ) === "00"
                                //         ? `Success`
                                //         : `Failed`
                                //     }
                                //     className={
                                //       String(
                                //         formatMetaData(chi?.pdon_meta)?.card
                                //           ?.response_code
                                //       ) === "00"
                                //         ? `success`
                                //         : `failed`
                                //     }
                                //   />
                                // }
                                seven={
                                  <DateFragmentBox date={chi?.created_at} />
                                  // chi?.created_at
                                  //   ? formatDate(chi?.created_at)?.replace("—", "•")
                                  //   : "---"
                                }
                              />
                            );
                          }
                        )}
                      </RavenTable>
                    </div>
                    {/* big table end */}
                    {/* mobile wrap table start */}
                    <div className="mobile-table-box">
                      {insight_terminal_trx?.data?.map((chi: any, idx: any) => {
                        return (
                          <MobileTableCard
                            amountColor={
                              chi?.direction === "credit"
                                ? "#1ACE37"
                                : chi?.direction === "debit"
                                ? `#FF0F00`
                                : "#1ACE37"
                            }
                            text={
                              chi?.type === "transfer_out"
                                ? "Transfer out"
                                : chi?.type === "transfer_in"
                                ? "Transfer in"
                                : "Card"
                            }
                            title={
                              chi?.type === "pdon_card" && chi?.meta_data
                                ? maskCardNumber(
                                    formatMetaData(chi?.meta_data)?.card_pan
                                  )
                                : chi?.type === "pdon_card" && !chi?.meta_data
                                ? maskCardNumber(
                                    formatMetaData(chi?.pdon_meta)?.card
                                      ?.card_pan
                                  )
                                : chi?.type === "transfer_in"
                                ? `${
                                    formatMetaData(chi?.meta_data)?.source
                                      ?.first_name || ""
                                  } ${
                                    formatMetaData(chi?.meta_data)?.source
                                      ?.last_name || ""
                                  }`
                                : chi?.type === "transfer_out"
                                ? formatMetaData(chi?.meta_data)?.account_number
                                : chi?.reference || "---"
                            }
                            amount={
                              formatNumWithCommaNairaSymbol(chi?.amount) ||
                              "---"
                            }
                            textTwo={
                              chi?.type === "pdon_card"
                                ? `${detectCardType(
                                    formatMetaData(chi?.meta_data)?.card_pan
                                  )} Card`
                                : chi?.type === "transfer_in"
                                ? `${
                                    formatMetaData(chi?.meta_data)?.source
                                      ?.account_number
                                  } • ${
                                    formatMetaData(chi?.meta_data)?.source?.bank
                                  }`
                                : chi?.type === "transfer_out"
                                ? formatMetaData(chi?.meta_data)?.bank
                                : ""
                            }
                            smallText={
                              (
                                <DateFragmentBox date={chi?.created_at} />
                              ) as any
                            }
                            key={idx}
                            //   smallText={ref}
                            showImg
                            type={chi?.direction || " "}
                            onRowClick={() => {
                              setsingleObj(chi);
                              setShowModal((prev) => {
                                return { ...prev, view: true };
                              });
                            }}
                          />
                        );
                      })}
                    </div>
                    {/* mobile wrrap table end */}
                  </div>
                  {/* table content end */}
                </div>
                {/* transaction-dashboard index wrap end */}
              </div>
            </ContainerWrapper>
            {/* contianer end */}
          </>
        )}

        {/*  */}
      </DashboardLayout>
      {/* modal start */}
      <TransactionDetailModal
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, view: false };
          });
        }}
        detail={singleObj}
        visible={showModal?.view}
        // visible={showModal?.view || true}
      />
      <ExportModal
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, export: false };
          });
        }}
        visible={showModal?.export}
        // visible={showModal?.view || true}
      />
      <AlertReceivers
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, view_alert: false };
          });
        }}
        onDelete={(param: any) => {
          setSingleChild(param);
          setShowModal((prev) => {
            return { ...prev, delete_view_alert: true, view_alert: false };
          });
        }}
        onAdd={() => {
          setFromView(true);
          setShowModal((prev) => {
            return { ...prev, add_alert: true, view_alert: false };
          });
        }}
        visible={showModal?.view_alert}
      />
      <DeleteAlertRecieverModal
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, delete_view_alert: false, view_alert: true };
          });
        }}
        details={singleChild}
        visible={showModal?.delete_view_alert}
        onFinish={() => {
          getAlertRecieversFunction();
          setShowModal((prev) => {
            return { ...prev, delete_view_alert: false, view_alert: true };
          });
        }}
      />
      <AddAlertReceiver
        onClose={() => {
          if (fromView) {
            setShowModal((prev) => {
              return { ...prev, add_alert: false, view_alert: true };
            });
            setFromView(false);
          } else {
            setShowModal((prev) => {
              return { ...prev, add_alert: false };
            });
          }
        }}
        onFinish={() => {
          getAlertRecieversFunction();
          if (fromView) {
            setShowModal((prev) => {
              return { ...prev, add_alert: false, view_alert: true };
            });
            setFromView(false);
          } else {
            setShowModal((prev) => {
              return { ...prev, add_alert: false };
            });
          }
        }}
        visible={showModal?.add_alert}
        // visible={true}
        // onFinish={() => {

        // }}
      />
      {/* modal end */}
      <RavenModal
        className={`flier-modal-btn-box`}
        onBtnClick={() => {
          // setShowModal((prev) => {
          //   return {...prev, view_flier: false}
          // })
        }}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, view_flier: false };
          });
        }}
        visble={showModal?.view_flier}
        btnColor="deep-green-light"
      >
        <div className="flier-modal-wrap-box">
          <FlierTwoIndex
            color_code={addHashIfNeeded(
              actionCtx?.configDetails?.partnerInfo?.color_code
            )}
          />
        </div>
      </RavenModal>
      <CreateStreamModal
        visible={showModal?.create_stream_key}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, create_stream_key: false };
          });
        }}
        btnLabel="Create Stream Key"
        serial={decryptedserialVal()}
      />
      <ManageStreamModal
        visible={showModal?.manage_stream_key}
        serial={decryptedserialVal()}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, manage_stream_key: false };
          });
        }}
      />
    </>
  );
};

export default TerminalDetailsInsight;
